import { render, staticRenderFns } from "./jurisdiction.vue?vue&type=template&id=515adb5b&scoped=true&"
import script from "./jurisdiction.vue?vue&type=script&lang=js&"
export * from "./jurisdiction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515adb5b",
  null
  
)

export default component.exports